import React from "react";
import { usePermitRequestContext } from "../../../../contexts/PermitRequestContext";
import { useProjectConfigContext } from "../../../../contexts/ProjectConfigContext";
import { useTags } from "../../../../hooks/useTags";
import addRequestPageLang from "../../../../data/lang/add-request-page.lang";
import { formatCurrencyNis } from "../../../../helpers/formating-currency";
import { useSelectSaveReqConfirmModalData } from "../../../../stores/saveReqConfirmModal.store";
import style from '../../style.module.scss';


function ConfirmationContent() {

    const { projectConfigState } = useProjectConfigContext();
    const { savePermitProcessResult } = useSelectSaveReqConfirmModalData();
    const { Formik } = usePermitRequestContext();
    const { values } = Formik;
    const { projectId } = projectConfigState;
    const { permitRequestId, asmachta, amountPayed } = savePermitProcessResult;

    const fullName = `${values.personDetails.privateName} ${values.personDetails.familyName}`;

    const generateTag = useTags();

    const cofirmationContentNameTag = generateTag(addRequestPageLang, 'confirmation-receive-modal.cofirmation-content-name');
    const p1 = generateTag(addRequestPageLang, 'confirmation-receive-modal.line-1');
    const p2 = generateTag(addRequestPageLang, 'confirmation-receive-modal.line-2');
    const p3 = generateTag(addRequestPageLang, 'confirmation-receive-modal.line-3');
    const p4 = generateTag(addRequestPageLang, 'confirmation-receive-modal.line-4');
    const p5 = generateTag(addRequestPageLang, 'confirmation-receive-modal.line-5');
    const p61 = generateTag(addRequestPageLang, 'confirmation-receive-modal.line-6');
    const p62 = generateTag(addRequestPageLang, 'confirmation-receive-modal.line-7')
    let p8 = generateTag(addRequestPageLang, 'confirmation-receive-modal.line-8');
    let p9 = generateTag(addRequestPageLang, 'confirmation-receive-modal.line-9');

    const p10 = generateTag(addRequestPageLang, 'confirmation-receive-modal.line-10');
    const p11 = generateTag(addRequestPageLang, 'confirmation-receive-modal.line-11');



    return (
        <div className={style.cofirmationContentDiv}>

            <div className={style.cofirmationContentName}>{`${cofirmationContentNameTag} ${fullName}`}</div>
            <div>
                <div>{p1}</div>
                <div>{p2}</div>
                <div>{p3}</div>
                <div className="fw-medium mt-1">{p4}</div>
                <div className="pl-1 pr-1 pb-1">
                    <div className="fw-medium">{p5}</div>
                    {projectId !== 87 && (
                        <div>
                            <span>{p61}</span> <span className="fw-medium">{p62}</span>
                        </div>
                    )}
                </div>
                <div>{p8} {permitRequestId}</div>
                {amountPayed > 0 && (<>
                    <div>{p9} {formatCurrencyNis(amountPayed)}</div>
                    <div>{p10} {asmachta}</div>
                </>)}
                <div className="mt-3">{p11}</div>
            </div>
        </div>
    );
}

export default ConfirmationContent;